import { Navigate } from "react-router-dom";
import { useAuth } from "@/components/auth/context/AuthContext";

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { isAuthenticated, user, initialized } = useAuth();

  if (!initialized) {
    return null;
  }

  const role = user?.role?.toLowerCase() ?? "";
  const isAdmin = role.includes("admin");

  if (!isAuthenticated || !isAdmin) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

export default ProtectedRoute;
